export default class DateToString {

  public static convertTimeToString(hour: number): string {
    const split = hour.toString().split('.');
    let result = "";
    if (split[0] !== "0") result = split[0] + "h";
    if (split.length > 1) {
      if (result.length > 0) result += " ";
      result += DateToString.convertMinutesNumberToString(split[1]) + "min";
    }
    if (result.length === 0) {
      result = "0h";
    }
    return result;
  }

  public static convertMinutesNumberToString(minute: string): string {
    if (minute.length < 2) minute += "0";
    let final = (Math.round(parseInt(minute) * 60 / 100)).toString();
    if (final.length < 2) final = "0" + final;
    return final;
  }
}
